import React, { useState } from 'react'

import { INPUT_THEME, Input, Icon, Pagination, usePagination } from '@st-operations/uikit/src/v2'

import Select from '_components/select'
import { filterOrg, filterQuery, sortUsers } from './helper'

const Invitations = ({ invitations, handleReinvite, orgOptions }) => {
  const [query, setQuery] = useState('')
  const [orgSelected, setOrgSelected] = useState(null)

  const filteredInvitations = sortUsers(
    { type: 'email', direction: 'asc' },
    filterOrg(orgSelected, filterQuery(query, invitations))
  )
  const { page, toPage } = usePagination(filteredInvitations, 20)

  return (
    <div className="invitations">
      <div className="invitations__filters">
        <Input
          onChange={(value) => setQuery(value)}
          placeholder="Search users"
          theme={INPUT_THEME.SEARCH}
          value={query}
          iconStyle={{ left: 12, width: 16 }}
        />
        <Select
          placeholder="Filter by Org"
          options={orgOptions}
          onChange={(org) => setOrgSelected(org)}
          isClearable={true}
        />
        <Pagination
          options={{ length: page.quantity }}
          page={page.number - 1}
          onPageChange={(page) => toPage(page.label)}
        />
      </div>
      <div className="invitations__header">
        <div></div>
        <div>Email</div>
        <div>Org</div>
      </div>
      <hr />
      <For each="user" of={page.content}>
        <div key={user.token} className="invitations__user">
          <button onClick={() => handleReinvite(user)} className="action-button" title="Re-invite">
            <Icon color="#3D3C68" height="16px" icon="restart" type="fill" width="16px" />
          </button>
          <div>{user.email}</div>
          <div>{user.org}</div>
        </div>
      </For>
    </div>
  )
}

export default Invitations
